export const LinkedInAndTwitterEvents = {
    enter_email: {
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466796&fmt=gif",
    },
    create_password: {
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466812&fmt=gif",
    },
    enter_phone: {
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466820&fmt=gif",
    },
    answer_minimum_capital: {
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466828&fmt=gif",
    },
    click_fund_account: {
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466836&fmt=gif",
    },
    fund_account: {
        linkedin: "https://px.ads.linkedin.com/collect/?pid=1949468&conversionId=4466844&fmt=gif",
    },
};
